import * as ngCore from '@angular/core'

@ngCore.Pipe({
  name: 'atnDsStripHtml',
})
export class Pipe implements ngCore.PipeTransform {
  /** @inheritdoc  */
  public transform(htmlString: string | undefined): string {
    if (!htmlString) {
      return ''
    }
    return new DOMParser().parseFromString(htmlString, 'text/html').body
      .innerText
  }
}
